import { app } from '../../../../app';

app.component('integrationYouAreDone', {
    templateUrl: require('./integration-you-are-done.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-applications/integration-you-are-done/integration-you-are-done.component.js